import { useRef, useState } from "react";
import { Img, DemoAction } from "./shared";

function MiniCompare() {
  const [v, setV] = useState(50);
  const ref = useRef(null);
  const move = (e) => {
    const r = ref.current.getBoundingClientRect();
    setV(Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100)));
  };
  return (
    <div ref={ref} data-noswipe className="relative h-full w-full select-none overflow-hidden" style={{ touchAction: "pan-y" }}
      onPointerDown={(e) => { e.currentTarget.setPointerCapture(e.pointerId); move(e); }}
      onPointerMove={(e) => e.buttons && move(e)}>
      <Img k="car2" alt="Lack nach der Politur" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - v}% 0 0)` }}>
        <Img k="car2" alt="Lack vor der Politur" style={{ filter: "grayscale(.6) brightness(.7) contrast(.8) blur(.6px)" }} />
        <div className="absolute inset-0 opacity-40 mix-blend-overlay" style={{ background: "repeating-linear-gradient(115deg,#fff0 0 6px,#ffffff33 6px 7px)" }} />
      </div>
      <div className="absolute inset-y-0 w-[2px] bg-[#FF5A1F]" style={{ left: `${v}%` }} />
      <input type="range" min="0" max="100" value={v} onChange={(e) => setV(+e.target.value)} aria-label="Vergleich Vorher/Nachher" className="absolute inset-x-0 bottom-0 h-8 w-full opacity-0" />
      <span className="absolute left-3 top-3 bg-black/70 px-2 py-1 text-[10px] uppercase tracking-widest">Vorher</span>
      <span className="absolute right-3 top-3 bg-[#FF5A1F] px-2 py-1 text-[10px] uppercase tracking-widest text-black">Nachher</span>
    </div>
  );
}

export default function Fahrzeug({ wide, onCta }) {
  return (
    <div className="bg-[#08090B] text-[#E8E8E8]" style={{ fontFamily: "'Chakra Petch', sans-serif" }}>
      <header className="flex items-center justify-between px-5 pt-12 pb-4 text-[12px] uppercase tracking-[0.25em]" style={wide ? { paddingTop: 24, paddingLeft: 48, paddingRight: 48 } : undefined}>
        <span className="font-semibold">Lack<span className="text-[#FF5A1F]">werk</span></span><span className="text-white/60">Detailing Studio</span>
      </header>
      <section className={wide ? "grid grid-cols-2 items-center gap-10 px-12 py-10" : "px-5 pb-8"}>
        <div>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#FF5A1F]">Politur · Keramik · Innenraum</p>
          <h1 className={`mt-3 font-semibold uppercase leading-[0.95] ${wide ? "text-[60px]" : "text-[40px]"}`}>Glanz,<br />auf den Punkt.</h1>
          <p className="mt-4 text-[14px] leading-relaxed text-white/70">Fahrzeugaufbereitung mit Präzision und Licht – eine fiktive Designstudie.</p>
        </div>
        <div className={`relative overflow-hidden ${wide ? "h-[420px]" : "mt-6 h-[300px]"}`}>
          <Img k="car1" alt="Politur am Fahrzeug" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,transparent_30%,#08090B_90%)]" />
        </div>
      </section>
      <section className={wide ? "px-12 pb-14" : "px-5 pb-10"}>
        <h2 className="text-[22px] font-semibold uppercase">Vorher / Nachher</h2>
        <p className="mt-1 text-[12px] text-white/60">Regler ziehen – beispielhafte Darstellung</p>
        <div className={`mt-4 ${wide ? "h-[380px]" : "h-[260px]"}`}><MiniCompare /></div>
        <div className="mt-6 grid grid-cols-3 gap-px bg-white/10 text-center">
          {["Politur", "Keramik", "Innenraum"].map((x) => (
            <div key={x} className="bg-[#08090B] py-4"><div className="mx-auto mb-2 h-[3px] w-6 bg-[#FF5A1F]" /><span className="text-[12px] uppercase tracking-widest">{x}</span></div>
          ))}
        </div>
        <DemoAction label="Termin anfragen" onCta={onCta} className="mt-6 w-full bg-[#FF5A1F] py-4 text-[14px] font-semibold uppercase tracking-[0.2em] text-black" />
      </section>
    </div>
  );
}
